import { useState } from "react";
import { CourseMaterial } from "../coursesLoader";
import TermOrdersBannerTemplate from "./TermOrdersBannerTemplate";
import TermOrdersReturnDialog from "./TermOrdersReturnDialog";
import TermOrdersCopy from "./TermOrdersCopy";

const ReturnBanner = ({
  items,
  type,
}: {
  items: CourseMaterial[];
  type: "Campus" | "Shipping";
}) => {
  const [showingDialog, setShowingDialog] = useState(false);
  const variant = type === "Shipping" ? "return items" : "return items campus";

  const values = {
    count: items?.length,
    studentEmail: items[0]?.orderInfo?.studentEmailAddress ?? "",
  };

  const content = (
    <TermOrdersCopy type="content" variant={variant} values={values} />
  );

  return (
    <>
      <TermOrdersBannerTemplate
        type="Alert"
        title={<TermOrdersCopy type="title" variant={variant} />}
        content={content}
        CTAText={<TermOrdersCopy type="cta" variant={variant} />}
        onCTAClick={() => setShowingDialog(true)}
      />
      {showingDialog && (
        <TermOrdersReturnDialog
          onRequestClose={() => setShowingDialog(false)}
          description={content}
          itemsToReturn={items}
        />
      )}
    </>
  );
};

export default ReturnBanner;
